export default "__VITE_ASSET__417f2313__"